import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Swatch = styled.img`
  width: 100%;
  border-radius: ${props => (!props.selectKey ? '0' : '50%')};
  -moz-border-radius: ${props => (!props.selectKey ? '0' : '50%')};
  -webkit-border-radius: ${props => (!props.selectKey ? '0' : '50%')};
  border: ${props => (props.active ? `2px solid #000 ` : `2px solid #fff`)};
  cursor: pointer;
  background: ${props => (props.active ? `#000` : ``)};
  // -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  // -moz-box-sizing: border-box; /* Firefox, other Gecko */
  // box-sizing: border-box;
  transition: all 0.2s ease-in-out;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const SwatchContainer = styled.div`
  width: ${props => props.width};
  margin: 3.5px;
  position: relative;
`;

const Pointer = styled.div`
  width: 1px;
  height: 1px;
  border-style: solid;
  border-width: 0px 4px 5px;
  border-color: transparent transparent #a5a7aa transparent;
  margin: auto;
  display: ${props => (props.display ? `block` : 'none')};
`;

export default class Swatches extends PureComponent {
  onClick(value) {
    const { selectKey, onClick, moveNodeToHome } = this.props;
    onClick(selectKey, value);
    if (!selectKey && moveNodeToHome) moveNodeToHome();
  }

  render() {
    const {
      col,
      images,
      active,
      onClick,
      activeArrow,
      attribute,
      selectKey,
    } = this.props;

    const width = activeArrow
      ? `calc(${100 / col}% - 15px)`
      : `calc(${100 / col}% - 7px)`;
    const values = attribute && attribute.values;
    return (
      <Grid>
        {images.map(img => {
          let hasImage = true;
          if (values) {
            hasImage = values.indexOf(img.value) !== -1;
          }
          return (
            img &&
            hasImage && (
              <SwatchContainer key={img.url} width={width}>
                <Swatch
                  selectKey={selectKey}
                  src={img.url}
                  active={!activeArrow && active && img.value === active}
                  onClick={e => this.onClick(img.value)}
                />

                <Pointer
                  display={activeArrow && active && img.value === active}
                />
              </SwatchContainer>
            )
          );
        })}
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Swatches.js